var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{attrs:{"rounded":"","small":"","text":"","color":"secondary","title":"Nota Fiscal","icon":_vm.isMobile()},on:{"click":function($event){return _vm.imprimirNotaFiscal()}}},[_c('v-icon',{attrs:{"left":!_vm.isMobile()}},[_vm._v("mdi-file-document-outline")]),_vm._v(" "),(!_vm.isMobile())?_c('span',[_vm._v("Nota fiscal")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }